import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "homeWrapper"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "customTop" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "The Library"),
  /*#__PURE__*/_createElementVNode("h2", { style: {"line-height":"30px"} }, "After staking your NFT, they will be locked for 30 days and you'll receive 30 $LUV as an advance on your staking yield. You'll need to re-stake after 30 days to receive your next LUV advance.")
], -1)
const _hoisted_3 = { class: "stats" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", null, "Total Staked", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", null, "% of NFT Staked", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "Base Rate"),
  /*#__PURE__*/_createElementVNode("h2", null, [
    /*#__PURE__*/_createTextVNode("2 "),
    /*#__PURE__*/_createElementVNode("b", null, "$LUV per day")
  ])
], -1)
const _hoisted_7 = {
  key: 1,
  class: "farmScreen"
}
const _hoisted_8 = {
  key: 0,
  class: "loadingAnimation"
}
const _hoisted_9 = {
  key: 1,
  class: "neverStaked"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "customTop" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "The Library")
], -1)
const _hoisted_11 = { class: "with-title stakeStats" }
const _hoisted_12 = { class: "stat-status" }
const _hoisted_13 = { class: "bar" }
const _hoisted_14 = { class: "flex" }
const _hoisted_15 = { class: "libraryStats" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h1", null, "Your wallet", -1)
const _hoisted_17 = { class: "libraryStats" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h1", null, "Balance", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(0)),
  /*#__PURE__*/_createElementVNode("b", null, "$LUV")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "libraryStats" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Rate"),
  /*#__PURE__*/_createElementVNode("h2", null, [
    /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(0)),
    /*#__PURE__*/_createElementVNode("b", null, "$LUV per day")
  ])
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "libraryStats" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Earned"),
  /*#__PURE__*/_createElementVNode("h2", null, [
    /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(0)),
    /*#__PURE__*/_createElementVNode("b", null, "$LUV")
  ])
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_23 = { class: "flex items-stretch stakeSection" }
const _hoisted_24 = { class: "chooseScreenOptions" }
const _hoisted_25 = {
  key: 0,
  class: "nftBox"
}
const _hoisted_26 = { class: "flex flex-wrap" }
const _hoisted_27 = { class: "outerCard" }
const _hoisted_28 = {
  class: "flex gapThis",
  style: {"margin-top":"50px"}
}
const _hoisted_29 = {
  key: 0,
  class: "loadingAnimation"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("h4", { style: {"font-style":"italic","opacity":"1","color":"#f1f1f1","text-align":"center"} }, " Looks like you've never staked with us before! Click the button below to initialize your account with the smart contract and begin staking. ", -1)
const _hoisted_31 = {
  key: 1,
  class: "nftBox"
}
const _hoisted_32 = { class: "flex flex-wrap" }
const _hoisted_33 = { class: "outerCard" }
const _hoisted_34 = {
  class: "flex gapThis",
  style: {"margin-top":"50px"}
}
const _hoisted_35 = {
  key: 0,
  class: "loadingAnimation"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("h4", { style: {"font-style":"italic","opacity":"1","color":"#f1f1f1","text-align":"center"} }, " Looks like you've never staked with us before! Click the button below to initialize your account with the smart contract and begin staking. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfigPane = _resolveComponent("ConfigPane")!
  const _component_Vault = _resolveComponent("Vault")!
  const _component_DisplayRefresh = _resolveComponent("DisplayRefresh")!

  return (!_ctx.wallet)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _hoisted_4,
            _createElementVNode("h2", null, _toDisplayString(_ctx.farmAcc ? _ctx.farmAcc.gemsStaked : 0), 1)
          ]),
          _createElementVNode("div", null, [
            _hoisted_5,
            _createElementVNode("h2", null, _toDisplayString(_ctx.farmAcc ? ((_ctx.farmAcc.gemsStaked / _ctx.collectionSize)*100).toFixed(2) : 0) + "%", 1)
          ]),
          _hoisted_6
        ]),
        _createVNode(_component_ConfigPane)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
        (_ctx.changingWallets)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.farmerAcc)
                ? (_openBlock(), _createBlock(_component_Vault, {
                    key: _ctx.farmerAcc,
                    class: "mb-10",
                    vault: _ctx.farmerAcc.vault.toBase58(),
                    reward: _ctx.farmerAcc.rewardA,
                    onSelectedWalletNft: _ctx.handleNewSelectedNFT
                  }, null, 8, ["vault", "reward", "onSelectedWalletNft"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("h1", null, _toDisplayString(((_ctx.farmAcc.gemsStaked / _ctx.collectionSize)*100).toFixed(2)) + "% staked", 1),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", {
                            style: _normalizeStyle({width: `${((_ctx.farmAcc.gemsStaked / _ctx.collectionSize)*100)}%`})
                          }, null, 4)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _hoisted_16,
                          _createElementVNode("h2", null, _toDisplayString(_ctx.shortenAddress(_ctx.getWallet()!.publicKey!.toString())), 1)
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createVNode(_component_DisplayRefresh, {
                            key: _ctx.farmerAcc,
                            farm: _ctx.farm,
                            farmAcc: _ctx.farmAcc,
                            farmer: _ctx.farmer,
                            farmerAcc: _ctx.farmerAcc,
                            class: "mb-10",
                            onRefreshFarmer: _ctx.handleRefreshFarmer
                          }, null, 8, ["farm", "farmAcc", "farmer", "farmerAcc", "onRefreshFarmer"]),
                          _hoisted_18,
                          _hoisted_19
                        ]),
                        _hoisted_20,
                        _hoisted_21
                      ]),
                      _hoisted_22
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("button", {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showScreen = 'Wallet')),
                          style: _normalizeStyle(_ctx.showScreen === 'Wallet' ? {background: '#A42F74'} : {background: 'transparent'})
                        }, "Study Group (" + _toDisplayString(0) + ")", 4),
                        _createElementVNode("button", {
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showScreen = 'Vault')),
                          style: _normalizeStyle(_ctx.showScreen !== 'Wallet' ? {background: '#A42F74'} : {background: 'transparent'})
                        }, _toDisplayString(_ctx.farmerState === "staked" ? `Currently Studying (0)` : `In Library (0)`), 5)
                      ]),
                      (_ctx.showScreen === 'Wallet')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("div", _hoisted_27, [
                                _createElementVNode("div", _hoisted_28, [
                                  (_ctx.loading)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_29))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _hoisted_30,
                                        _createElementVNode("button", {
                                          class: "big-button",
                                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.initFarmer && _ctx.initFarmer(...args)))
                                        }, " Initialize ")
                                      ], 64))
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.showScreen === 'Vault')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                              _createElementVNode("div", _hoisted_33, [
                                _createElementVNode("div", _hoisted_34, [
                                  (_ctx.loading)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_35))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _hoisted_36,
                                        _createElementVNode("button", {
                                          class: "big-button",
                                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.initFarmer && _ctx.initFarmer(...args)))
                                        }, " Initialize ")
                                      ], 64))
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
            ], 64))
      ]))
}